export const urlsAPI = "https://dev-search.qx.live/api/predict/graph/urls";

export const articlePriceAPI = "https://ve2.kunato.ai/price";
export const chandlechartAPI = "https://ve2.kunato.ai/ohlc";
// export const chandlechartAPI = "https://beta-search.qx.live/api/predict/graph/ohlc/urls";
